import React from 'react';

import type { FrapiTeaserItem } from '../../../types/frapi-types.js';

import Teaser from '../../components/teasers/Teaser.js';
import { LinkWithPulse } from '../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';
import NextPagination from '../../components/commonComponents/NextPagination.js';

export type AuthorResultsProps = {
  currentPage: number;
  collection: FrapiTeaserItem[];
  resultsCount: number;
  isMobile: boolean;
  slug: string;
};

const PAGE_SIZE = 9;
export const AuthorResults: React.FC<AuthorResultsProps> = ({
  currentPage,
  collection,
  resultsCount,
  isMobile,
  slug,
}) => {
  const pagesCount = Math.ceil(resultsCount / PAGE_SIZE);
  let seen = (currentPage - 1) * PAGE_SIZE;
  if (currentPage < pagesCount) {
    seen += collection.length;
  } else {
    seen += resultsCount % PAGE_SIZE;
  }

  return (
    <div>
      <div className="author-teasers">
        <h2 className="results-title">Les mer fra meg</h2>
        <div className="results-info-wrapper">
          <div>{`${seen} av ${resultsCount} saker`}</div>
          <div>Sortert nyeste først</div>
        </div>
        <div className="author-articles-all">
          {collection.map((t, i) => (
            <Teaser
              {...t}
              key={t.id}
              index={i}
              size="medium"
              mobile={isMobile}
              fullWidthTeaser={false}
              lazyLoad={false}
            />
          ))}
        </div>
      </div>
      <NextPagination
        pageCount={pagesCount}
        currentPage={currentPage}
        pageId={slug}
        location="vink-redaksjonen"
      />
      <LinkWithPulse
        className="homescreen-button"
        href="/"
        id="redirect-to-homescreen"
        name="Redirect to homescreen"
      >
        Gå til Vink-forsiden
      </LinkWithPulse>
    </div>
  );
};
